// extracted by mini-css-extract-plugin
export default {"body":"learnpath_body__ZJ3Ep","detailsItem":"learnpath_detailsItem__nCVro","active":"learnpath_active__0KuSa"};